import { pageTypes } from 'config/pageTypes';
import Mini1 from 'assets/images/psp/FeaturedImages/self2.webp';
import Mini2 from 'assets/images/psp/FeaturedImages/climate2.webp';
import Mini3 from 'assets/images/psp/FeaturedImages/bicycle-2.webp';
import Mini4 from 'assets/images/psp/FeaturedImages/stuff-in-unit.webp';

import MiniStorageIcon from 'assets/images/icons/psp/mover.svg';

import Renters from 'assets/images/psp/mini/renters.svg';
import Students from 'assets/images/psp/mini/students.svg';
import Families from 'assets/images/psp/mini/families.svg';
import Seasonal from 'assets/images/psp/mini/seasonal.svg';
import Transition from 'assets/images/psp/mini/transition.svg';
import Hobbies from 'assets/images/psp/mini/hobbies.svg';
import LockerAltImage from 'assets/images/sgp/alt-content-images/alt-content-image-optimized.webp';

import MiniStorageHero from 'assets/images/psp/hero/mini-storage-hero.webp';

const reviews = [
	{
		reviewTitle: 'Great service.',
		reviewRating: 5,
		reviewText:
			"I was promptly set up with a nice, clean 5x5 unit. The SpareFoot service was excellent. I'm very happy with your help.",
		reviewerInitials: 'DA',
		link: 'https://www.trustpilot.com/reviews/5ee6e23c7dd7530828c0f18b',
		reviewDate: 'June 15, 2020',
		reviewerName: 'David Alvarez',
	},
	{
		reviewTitle: 'SpareFoot has what you need.',
		reviewRating: 5,
		reviewText:
			"Making a move across the country, I wanted an inexpensive 5x5 unit. Well, SpareFoot had it. The size and at a price I can afford. Close to where I'll be. I'm glad that I was able to find just what I needed.",
		reviewerInitials: 'T',
		reviewerName: 'Terry',
		link: 'https://www.trustpilot.com/reviews/57fb387ba43068088c1c6b5d',
		reviewDate: 'October 10th, 2016',
	},
	{
		reviewTitle: 'Good customer service and great pricing.',
		reviewRating: 5,
		reviewText:
			'I called SpareFoot to reserve a 5x5 storage space from this company. My customer experience with them was great. I called the company from their website, and the next day, a manager at the storage facility called me and let me know they were holding it for me.',
		reviewerInitials: 'D',
		reviewerName: 'Devan',
		link: 'https://www.trustpilot.com/reviews/52f026de000064000274e0c1',
		reviewDate: 'February 4, 2014',
	},
	{
		reviewTitle: "Saw a great price! Couldn't beat it!",
		reviewRating: 5,
		reviewText:
			'I was looking for a cheaper 5x5 storage unit, and when I did a search, I saw SpareFoot. I called and made the appointment and reserved the unit the same day, within the same hour.',
		reviewerInitials: 'J',
		reviewerName: 'John',
		link: 'https://www.trustpilot.com/reviews/52ba119a00006400026cd592',
		reviewDate: 'December 25, 2013',
	},
];

export const alternateContentData = {
	props: {
		type: 'alternatingContent',
		title: 'Looking for a Small Storage Unit?',
		description:
			'If you’re here, chances are that you’re looking for a small storage unit to give your stuff a new home. Lucky for you, SpareFoot has a variety of storage unit sizes to suit your mini storage needs. Here’s your Goldilocks storage unit menu to help you find the best storage space:',
		additionalProps: {
			paragraph: {
				color: 'black',
			},
		},
		content: [
			{
				image: LockerAltImage,
				description: `**Medium Units:** 10x10, 10x15, 5x15
					\n **Small Units:** 5x5, 5x10, Mini storage (*you are here*), Storage lockers 
					\n **Large Units:** 10x20, 10x25, 10x30`,
			},
		],
	},
};

const threePanelBlock = {
	props: {
		title: 'Who Can Benefit from Mini Storage?',
		type: 'three-panel',
		pageType: 'SGP',
		content: [
			{
				image: Renters,
				description:
					'### Renters & Apartment Dwellers\n' +
					'- Limited closet and storage space\n' +
					'- No basement, attic, or garage\n' +
					'- Seasonal item rotation needs\n' +
					'- Downsizing from larger homes\n',
			},
			{
				image: Students,
				description:
					'### College Students\n' +
					'- [Dorm room limitations](https://www.sparefoot.com/blog/6-strategies-for-organizing-your-dorm-room)\n' +
					'- Summer break storage\n' +
					'- Study abroad programs\n' +
					'- Graduation transitions\n',
			},
			{
				image: Families,
				description:
					'### Growing Families\n' +
					'- Outgrown baby items to save \n' +
					'- Seasonal clothing storage\n' +
					'- Holiday decoration overflow\n' +
					'- Sports equipment accumulation\n',
			},
			{
				image: Seasonal,
				description:
					'### Seasonal Storage Needs\n' +
					'- [Winter/summer clothing rotation](https://www.sparefoot.com/blog/how-to-store-summer-clothes)\n' +
					'- Holiday decorations\n' +
					'- Recreational equipment (boats, RVs, motorcycles)\n' +
					'- Lawn and garden equipment\n' +
					'- Job relocations\n' +
					'- Downsizing seniors\n',
			},
			{
				image: Transition,
				description:
					'### People in Transition\n' +
					'- Between moves or home sales\n' +
					'- Divorce or relationship changes\n',
			},
			{
				image: Hobbies,
				description:
					'### Collectors & Hobbyists\n' +
					'- Craft supplies and materials\n' +
					'- Collections that outgrow home space\n' +
					'- Workshop tools and equipment\n' +
					'- Recreational gear storage\n',
			},
		],
	},
};

const faqs = [
	{
		question: 'Can I rent a climate controlled mini storage unit?',
		answer: 'Yes, most mini storage facilities offer climate-controlled units in both 5x5 and 5x10 sizes. Climate-controlled storage maintains consistent temperature (typically 55-85°F) and humidity levels year-round, protecting your belongings from extreme weather conditions. These units are ideal for storing electronics, wooden furniture, important documents, artwork, musical instruments, and clothing. Climate-controlled mini storage units typically cost $10-20 more per month than standard mini storage units but provide advanced protection. When searching for "climate-controlled storage near me," look for facilities that offer this premium feature in smaller unit sizes.',
	},
	{
		question: 'What is the biggest mini storage unit I can rent?',
		answer: "Most mini storage facilities offer sizes ranging from 5x5 units up to 5x10 units. If you're looking for a larger-sized storage unit, you'll want to expand your search to common self-storage unit sizes.",
	},
	{
		question: 'Do I need rental insurance for mini storage?',
		answer: "While mini storage rental insurance isn't legally required, it's highly recommended to protect your stored belongings. Your homeowner's or renter's insurance may provide limited coverage for items in storage, but this coverage is often minimal. Most mini storage facilities offer tenant insurance plans starting at $8-15 per month, covering $2,000-5,000 worth of stored items.",
	},
	{
		question: 'Is mini storage worth it?',
		answer: "At $35-85 per month for most units, mini storage costs less than upgrading to a larger apartment or home. It's particularly worthwhile for apartment dwellers, college students, military families, and anyone in transition who needs temporary space. Mini storage pays for itself when it helps you avoid buying duplicate items, allows you to keep sentimental belongings, or enables downsizing to save on housing costs.",
	},
];

export const MiniContent = {
	type: 'mini',
	pageType: pageTypes.SGP,
	sections: [
		{
			title: 'Mini Storage Hero',
			background: 'yellow',
			modules: [
				{
					type: 'hero',
					id: 'mini-storage-hero',
					background: 'lighterYellow',
					props: {
						content: {
							title: 'What is Mini Storage?',
							pageType: pageTypes.SGP,
							description:
								'You might have heard the term “mini storage” before and wondered what the difference between mini storage and self-storage is. To put it simply, mini storage units and lockers are self-storage units on the smaller end of the size spectrum, often ranging from 5x5 to 5x10 feet with a shorter ceiling height. Storage facilities that offer mini storage solutions provide affordable, basic storage for personal items, seasonal goods, and valuables that take up a smaller space. \n\n' +
								'Mini storage sounds right for you? SpareFoot is here to help. ',
							image: MiniStorageHero,
							CTAText: 'Find Mini Storage',
							inputLabel: 'Find Your Ideal Mini Storage Unit',
						},
						additionalProps: {
							heading: {
								family: 'rounded',
								size: 'large',
								color: 'black',
							},
						},
					},
				},
			],
		},
		{
			title: 'nearby storage',
			background: 'gray',
			modules: [
				{
					type: 'facilitiesNearYou',
					props: {
						title: 'Popular Facilities Near',
					},
				},
			],
		},
		{
			title: 'alternate content',
			background: 'white',
			modules: [
				{
					type: 'alternatingContent',
					props: alternateContentData,
					id: 'locker-alternate-content',
				},
			],
		},
		{
			title: 'How to Take Your Car Out of Storage',
			background: 'gray',
			modules: [
				{
					type: 'commonSectionHeader',
					props: {
						title: 'Popular Mini Storage Sizes',
						description:
							'The two most commonly found mini storage sizes offer enough extra storage space to hold the contents of a walk-in closet or even a small bedroom. Mini storage units typically come with the standard amenities of larger storage units, such as the option for climate control, with smaller square footage allotments.',
						image: MiniStorageIcon,
						titleProps: {
							family: 'rounded',
							size: 'large',
							color: 'black',
						},
					},
				},
				{
					type: 'sizeChart',
					props: {
						columnWidths: [2, 3, 3],
						headers: [
							{
								label: 'Feature',
								key: 'feature',
							},
							{
								label: '5x5 Unit',
								key: '5x5',
							},
							{
								label: '5x10 Unit',
								key: '5x10',
							},
						],
						rows: [
							{
								feature: {
									type: 'markdown',
									markdown: '**Size**',
								},
								'5x5': "5' × 5' (25 sq ft)",
								'5x10': "5' × 10' (50 sq ft)",
							},
							{
								feature: {
									type: 'markdown',
									markdown: '**Comparasion**',
								},
								'5x5': 'Walk-in closet',
								'5x10': 'Small bedroom',
							},
							{
								feature: {
									type: 'markdown',
									markdown: '**Cost**',
								},
								'5x5': '$35-55/month',
								'5x10': '$55-85/month',
							},
							{
								feature: {
									type: 'markdown',
									markdown: '**What Fits**',
								},
								'5x5': 'Bedroom furniture, 15-20 boxes, seasonal items',
								'5x10': 'Studio apartment contents, major appliances, 30-40 boxes',
							},
							{
								feature: {
									type: 'markdown',
									markdown: '**Best For**',
								},
								'5x5': 'Seasonal storage, small furniture',
								'5x10': 'Moving storage, appliances, and business inventory',
							},
							{
								feature: {
									type: 'markdown',
									markdown: '**Vehicle Storage**',
								},
								'5x5': 'No',
								'5x10': {
									type: 'markdown',
									markdown:
										'Motorcycle, [jet ski](https://www.sparefoot.com/blog/how-to-store-your-jet-ski)',
								},
							},
							{
								feature: {
									type: 'markdown',
									markdown: '**Access**',
								},
								'5x5': 'Limited (stacking needed)',
								'5x10': 'Easy (aisle space)',
							},
						],
					},
				},
				{
					type: 'content',
					props: {
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							'Storage space even [smaller than traditional mini storage can be found in storage lockers](/storage-unit-size-guide/storage-lockers.html), which start at 3x3.',
						],
					},
				},
			],
		},
		{
			title: 'price-factors',
			background: 'white',
			modules: [
				{
					type: 'cardBlockContent',
					id: 'threePanelBlock',
					props: threePanelBlock,
				},
			],
		},

		{
			title: 'Reviews Section',
			background: 'dark',
			modules: [
				{
					type: 'reviews',
					props: {
						reviews,
						title: "It's Easy to Find & Reserve a Storage Locker with SpareFoot",
					},
				},
			],
		},
		{
			title: 'Faqs Section',
			background: 'gray',
			modules: [
				{
					type: 'faqs',
					props: {
						header: 'Mini Storage Size FAQs',
						faqs,
					},
				},
			],
		},
		{
			title: 'featured content',
			modules: [
				{
					type: 'featuredContent',
					props: {
						slug: 'rv-featured-content',
						pageType: pageTypes.SGP,
						title: 'Learn More About Storage Unit Size Options',
						contentCards: [
							{
								title: 'General Storage Advice',
								date: 'August 7, 2025',
								image: Mini1,
								link: 'https://www.sparefoot.com/blog/how-to-pick-the-right-size-storage-unit',
								content:
									'How to Pick the Right Size Self Storage Unit',
							},
							{
								title: 'General Storage Advice',
								date: 'October 17, 2025',
								image: Mini2,
								link: 'https://www.sparefoot.com/blog/how-are-storage-units-measured',
								content: 'How Are Storage Units Measured?',
							},
							{
								title: 'General Storage Advice',
								date: 'October 17, 2025',
								image: Mini3,
								link: 'https://www.sparefoot.com/blog/5x5-storage-unit-size-guide',
								content:
									'What Can You Fit Inside a 5x5 Storage Unit?',
							},
							{
								title: 'Self Storage',
								date: 'October 29, 2025',
								image: Mini4,
								link: 'https://www.sparefoot.com/blog/50-things-you-can-store-in-5x10-storage-unit',
								content:
									'50 Things That Fit Inside a 5x10 Storage Unit',
							},
						],
					},
				},
			],
		},
		{
			title: 'Link to other PSPs',
			background: 'gray',
			modules: [
				{
					type: 'links',
					props: {
						title: 'More Ways to Store',
						pageType: 'SGP',
						cards: [
							'ClimateControl',
							'College',
							'5x5',
							'StorageLockers',
						],
					},
				},
			],
		},
		{
			title: 'nearby units',
			modules: [
				{
					type: 'storageNearYou',
				},
			],
		},
	],
};
